 function resetOrientation() {
}

